import { ChatHeader } from '../components/ChatHeader'
import { ChatMessages } from '../components/ChatMessages'
import { ChatInteractionBox } from '../components/ChatInteractionBox'

function ChatPage() {
    return (
        <div className="chat-container">
            <ChatHeader />
            <ChatMessages />
            <ChatInteractionBox />
        </div>
    );
}

export { ChatPage }